import HttpClientToken from '../../services/HttpClientToken';

import { defaultSentidoFallo, SentidoFalloProps } from '../../interfaces/catalogos/SentidoFalloInterface';

export const SentidoFallo = () => {

    return new Promise<SentidoFalloProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/SentidoFallo/', token)
            .then( ({ data } : { data : SentidoFalloProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerSentidoFallo = () => {

    return new Promise<SentidoFalloProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/SentidoFallo/ObtenerSentidoFallo', token)
            .then( ({ data } : { data : SentidoFalloProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarSentidoFallo = ( params: SentidoFalloProps ) => {

    return new Promise<SentidoFalloProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SentidoFallo/Actualizar', params, token)
            .then( ({ data } : { data : SentidoFalloProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSentidoFallo } );
            });

        }

    });

}

export const AgregarSentidoFallo = ( params: SentidoFalloProps ) => {

    return new Promise<SentidoFalloProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SentidoFallo/Agregar', params, token)
            .then( ({ data } : { data : SentidoFalloProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSentidoFallo } );
            });

        }

    });

}
